/*
 | Barra de navegación de la web pública.
 |
 | Añade `compact` al superar 80 px de scroll y `on-dark` al inicio de un hero
 | oscuro. El fondo vive en su propia capa en site.css.
 */
export default function registerNav() {
    const nav = document.getElementById("site-nav");

    if (!nav) {
        return;
    }

    const hasHero = document.querySelector("[data-hero]") !== null;
    const overDarkHero = nav.dataset.dark !== undefined;
    let previousScrolled;
    let scheduled = false;

    const update = () => {
        scheduled = false;
        const scrolled = window.scrollY > 80;

        if (scrolled === previousScrolled) {
            return;
        }

        previousScrolled = scrolled;

        // Con hero (claro u oscuro) la barra se integra en él y gana fondo al hacer scroll;
        // sin hero (docs, carrito) lleva su fondo desde el principio.
        nav.classList.toggle("compact", scrolled || !hasHero);
        // Solo las páginas con hero oscuro (data-dark) llevan la barra clara al inicio.
        nav.classList.toggle("on-dark", !scrolled && hasHero && overDarkHero);
    };

    const scheduleUpdate = () => {
        if (!scheduled) {
            scheduled = true;
            window.requestAnimationFrame(update);
        }
    };

    update();

    window.addEventListener("scroll", scheduleUpdate, { passive: true });
    window.addEventListener("pageshow", scheduleUpdate);
}
